import { Environment, getEnvironment } from './env';

export const isDev = () => {
  const baseUrl = window.location.hostname;

  return baseUrl.includes('-dev');
};

export const isLocalDev = () => {
  const baseUrl = window.location.hostname;

  return baseUrl.includes('localhost');
};

/**
 * A PR preview is the one throwaway full stack: its own Postgres, DynamoDB and
 * colugo, created and destroyed with the pull request (preview/README.md). The
 * hostname is the only thing the SPA can tell it by, so match the shape the
 * preview box hands out — pr<N>-<app>-dev.preview.vytal.org — rather than
 * anything as loose as "not production".
 */
const PREVIEW_HOSTNAME = /^pr\d+-[a-z0-9-]+-dev\.preview\.vytal\.org$/;

export const isPreviewHost = (
  hostname: string = window.location.hostname,
): boolean => PREVIEW_HOSTNAME.test(hostname);

/**
 * Only production runs a ClickHouse cluster, so a page reading it has nothing
 * to show anywhere else. getEnvironment is the one place that knows which
 * hostname is which, and it throws on an unrecognised one — which is not
 * production either.
 */
export const hasClickHouse = () => {
  try {
    return getEnvironment() === Environment.Production;
  } catch {
    return false;
  }
};
